module.exports = __webpack_public_path__ + "img/Insights-Mac-Monitor.2101f791.png";